<template>
  <div>
  <CModal :show="cookies"  fullHeight position="center">
      <mdbModalHeader center :close="true" slot="header" class="p-0 m-0">
          <p class="heading m-0"><mdb-icon icon="exclamation-circle" class="icono-error m-2" /> Información </p>
        </mdbModalHeader>
    <mdbModalBody class="text-center">
        <p class="center">{{message}}</p>
    </mdbModalBody>
    <mdbModalFooter center slot="footer" class="m-0">
      <CButton color="primary" @click="closedialogue">OK</CButton>
    </mdbModalFooter>
  </CModal>

  <div class="animated fadeIn">
    <CRow>
      <CCol sm="12">
        <transition name="fade">
          <!-- <CCard  > -->
            <!--  <CCardHeader>
              <div class="card-header-actions">
                <CNav>
              
              <CDropdown
                  placement="bottom-end"
                  toggler-text="Comentarios"
                >
                  <CDropdownItem  >Análisis de los sentimientos</CDropdownItem>
                  <CDropdownItem >Comentario original</CDropdownItem>
                  
                </CDropdown>
            </CNav>
              </div>
            </CCardHeader> -->

            <!-- <CCardBody > -->
            <div v-if="reviewDetail.length==0">
              <CRow class=" p-3">
                <div class="medium   ">No Review...</div>
              </CRow>
            </div>
            <div  v-if="reviewDetail.length>0">
            <div  v-for="(item,index) in reviewDetail">
              <CRow  >
                    <!-- <div class="message col-sm-12  ">
                    <div class="message col-sm-12 p-3 border-bottom">
                    <div class="py-2 mfe-3 float-left">
                    <div class="c-avatar" v-if="item.url_reviewer_photo!==false" style="width:40px; height:40px">
                      <img class="c-avatar-img" :src="getImage(item.url_reviewer_photo)" alt="user@email.com" />
                    </div>
                    <div class="c-avatar" style="width:40px; height:40px" v-else>
                      <img class="c-avatar-img" src="img/logo_brand.png" alt="user@email.com" />
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <span class="text-muted float-right" v-for="star in item.starRating">
                      <i class="fa fa-star" aria-hidden="true"></i>
                    </span>

                    <span class="text-muted float-right mr-2">{{item.createTime | formatDate}}</span>
                  </div>
                  <div  class="text-truncate font-weight-bold">{{item.reviewer_name}}</div>
                  <div class="medium mt-3" v-if="item.comment!==false">{{item.comment}}</div>
                    <div class="medium mt-3" v-if="item.comment===false">Sin comentarios.</div>
                      <div class="col-sm-12 pb-4">
                        <CBadge color="light" class="float-right ml-2 p-2">
                          <i
                            class="fa fa-check text-muted"
                            aria-hidden="true"
                            v-if="item.reviewReply===false"
                          ></i>
                          <i
                            class="fa fa-check text-primary"
                            aria-hidden="true"
                            v-if="item.reviewReply!==false"
                          ></i>
                        </CBadge>
                        <CBadge color="light" class="float-right p-2">
                          <i class="fa fa-heart" aria-hidden="true"></i>
                        </CBadge>
                      </div>
                    </div>
                  </div> -->

                  <div class="col-md-10 m-auto">

                    <div class="rew">
                        <div class="row">
                          <div class="col-md-4" v-if="item.url_reviewer_photo!==false" >
                            <!-- <img src="img/user-dummy.png"> -->
                            <img class="c-avatar-img" :src="getImage(item.url_reviewer_photo)" alt="user@email.com" />
                          </div>
                          <div class="col-md-4"  v-else>
                            <img class="c-avatar-img"  src="img/logo_brand.png" alt="user@email.com" />
                            <!-- <span class="c-avatar-status bg-success"></span> -->
                          </div>
                          <div class="col-md-8">
                            <h3>{{item.reviewer_name}} 
                              <span class="text-muted float-right" v-for="star in item.starRating">
                                <i class="fa fa-star" aria-hidden="true"></i>
                              </span>
                            </h3>
                            <h5>{{item.createTime | formatDate}}</h5>

                           <!--  <p v-if="item.comment!==false">{{item.comment}}</p>
                            <p v-if="item.comment==false">Sin comentarios.</p> -->


                           <div class="col-md-12 medium" v-if="translation==true">
                            <div v-if="item.comment_eng===false">No Comments.</div>
                            <div
                              v-if="item.comment_eng!==false" >{{item.comment_eng}}</div>
                          </div>
                          <div class="col-md-12 medium " v-if="translation==false">
                            <div v-if="item.comment===false">Sin comentarios.</div>
                            <div v-if="item.comment!==false">{{item.comment}}</div>
                          </div>
                          <div class="medium mt-3 pb-3 border-bottom" @click="translate(translation)"><span v-if="translation==false">Ver traducción</span>
                          <span v-if="translation==true">Ver original</span>
                          </div>

                            <CRow class="col-md-12 mt-4" v-if="item.reviewReply!==false">
                              <!-- <div class="rew">
                              <div class=""> -->

                              <div class="text-truncate font-weight-bold">Respuesta:</div>

                                <div class="col-md-12 text-muted">
                                  {{item.reviewReply}} 
                                  <small
                                    class="text-muted float-right"
                                  >{{item.reply_updateTime | formatDate}}</small>
                                </div>
                                <!-- </div>
                                </div> -->
                              </CRow>

                          </div>
                        </div>
                      </div>
                    </div>
                </CRow>

                  <CRow  >
                    <div class="col-md-10 m-auto">
                    <div class="">
                    <div class="row">
                    <div class="col-md-12 m-auto pt-3">
                      <mdb-input
                        class="mb-3 mt-0"
                        placeholder="Answer should be here"
                        v-model="reply_text"
                        required
                      ></mdb-input>
                    </div>

                    <div class="col-sm-12 mt-2 pb-2">
                      <!-- <span class="float-left mr-2">
                      <CIcon name="cilCommentSquare"></CIcon>
                      </span>-->
                      <span class="float-left mr-2">
                        <emoji-picker @emoji="insert" :search="search">
                          <div
                            class="emoji-invoker"
                            slot="emoji-invoker"
                            slot-scope="{ events: { click: clickEvent } }"
                            @click.stop="clickEvent"
                          >
                            <CIcon name="cilSmile"></CIcon>
                          </div>

                          <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                            <div class="emoji-picker">
                              <div class="emoji-picker__search">
                                <input type="text" v-model="search" v-focus />
                              </div>
                              <div>
                                <div v-for="(emojiGroup, category) in emojis" :key="category">
                                  <h5>{{ category }}</h5>
                                  <div class="emojis">
                                    <span
                                      v-for="(emoji, emojiName) in emojiGroup"
                                      :key="emojiName"
                                      @click="insert(emoji)"
                                      :title="emojiName"
                                    >{{ emoji }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </emoji-picker>
                      </span>
                      <span>
                        <CBadge
                          color="danger"
                          class="float-right p-2"
                          v-if="item.reviewReply===false"
                          @click="reviewReplySubmit(item.id)"
                        >Enviar</CBadge>
                        <CBadge
                          color="danger"
                          class="float-right p-2 ml-2"
                          v-if="item.reviewReply!==false"
                          @click="reviewReplySubmit(item.id)"
                        >Editar respuesta</CBadge>
                        <CBadge
                          color="danger"
                          class="float-right p-2 "
                          v-if="item.reviewReply!==false"
                          @click="reviewReplyDelete(item.id)"
                        >Eliminar respuesta</CBadge>
                      </span>
                    </div>
                    </div>
                    </div>
                    </div>
                  </CRow>
              </div>
              </div>
            <!-- </CCardBody>
          </CCard> -->
        </transition>
      </CCol>
      <CCol sm="4">
        <!--<transition name="fade">
          <CCard  >
            <CCardHeader>
              <div class="card-header-actions">
                <CLink href="#" class="card-header-action btn-close">
                  <CIcon name="cil-plus"/>
                </CLink>
              </div>
            </CCardHeader>
              <CCardBody  class="text-center">
                <CIcon width="60" height="60" name="cibFacebookF"/>
              </CCardBody>
          </CCard>
        </transition>-->
      </CCol>
      
    </CRow>
  </div>
</div>
</template>
<style>
  .rew img{ width: 320px; }
  .rew {background-color: #fbfbfb; box-shadow: #6765651c 0 0 18px 9px; margin-top:50px;  padding: 60px 40px;}
  .rew h3{font-weight: 600; font-size: 22px; padding-top: 15px; position: relative;}
  .rew h3 span{font-size: 16px; color: red; font-weight: 800; float: right;}
  .rew h3:before {content: ''; width: 30px; height: 2px; background-color: #3c4b64; top: 45px; left: 4px; position: absolute;}
  .rew h5 {font-size: 12px; color: #929292; padding-top: 10px;}
  .rew p{font-size: 14px; line-height: 26px; padding-top: 10px;}
  .rew p span{font-size: 25px;}



.tabnav .nav-link {
  display: block;
    padding: 0.5rem 5px;
    font-size: 12px;
}
.firstcol .card-body{
  padding: 10px 7px;
}

/* This demo uses Tailwind v0.6.4 */

/*
.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}*/
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 25rem;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
</style>
<script>
import store from "../../store";
import moment from "moment";
import EmojiPicker from "vue-emoji-picker";
import { mdbInput } from "mdbvue";

export default {
  name: 'ReviewPage',
  components: {
    mdbInput,
  },
    props: ["itemID"],

  data: function () {
    return {
      show: true,
      isCollapsed: true,
      loremIpsum: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.',
      reviewDetail:[],
      reply_text:"",
      cookies:false,
      message:"",
      translation: false,
    }
  },
  async mounted(){
    await this.getReviewDetail()
  },
  methods:{

    getImage(pic){

          return pic
    },

    translate(t) {
      this.translation = !t;
      //////console.log("this.translation ", t, this.translation);
    },
    closedialogue(){
      // console.log("here in 378");
      this.cookies = false;
      location.reload();

    },
    async getReviewDetail() {
      var gbareview = [];
      this.isLoadingReview = true;
      console.log("this.$route.params :: ", this.$route.params.itemID);
      // const item_id = Number(this.$route.params.itemID);

      // var create_date = "";
      // if(this.date!="" && this.date!==null){
      //   create_date = moment(this.date).format('YYYY-MM-DD');
      // }
      
      var payload={
        // "location_id": this.idNumber,
        // "createTime": create_date,
        // "scoreTag" : this.scoreTagSelected,
        // "starRating" : Number(this.starRatingSelected),
        // "reviewReply_type":reviewReply_type,
        // "offset": this.offset_review
        item_id : Number(this.$route.params.itemID)
      };
      var reviewDetail=[];
      store.dispatch("getReviewDetail", payload).then(() => {
        reviewDetail = store.getters.getReviewDetail;
        console.log("reviewDetail :::: ", reviewDetail);
        if (reviewDetail.length > 0) {
            // this.totalreviews = gbareview.length;
            this.reviewDetail = reviewDetail;
        } else {
          this.reviewDetail = [];
          
        }
      });
      this.isLoadingReview = false;

    },

    reviewReplySubmit(id) {
      //////console.log("In submit", this.reply_text, id);
      var reply_text = this.reply_text;
      var review_id = id;
      var reply = {
        reply_text: reply_text,
        review_id: review_id,
      };
      if(reply_text !=""){
        store.dispatch("reviewReplyWizard", reply).then((res) => {
          this.reply_text = "";
          // var loc_id = this.idNumber;
          ////console.log("locid type", this.type_Selected, loc_id, res);
          // this.selected_location =[];

          this.cookies=true;
          this.message="Mensaje enviado con éxito";
          // this.showIdDetails(this.selected_location, loc_id);
          // location.reload();
        });
      }else{
         this.cookies=true;
          this.message="La respuesta no puede estar en blanco";
      }
    },
    reviewReplyDelete(id) {
      //////console.log("In Delete", id);
      var review_id = id;
      
      store.dispatch("getreviewDelete", review_id).then((res) => {
        // var loc_id = this.idNumber;
        //////console.log("locid type", this.type_Selected, loc_id);
        // this.selected_location =[];
        // location.reload();
        this.cookies=true;
        this.message="Mensaje borrado";
        // this.showIdDetails(this.selected_location,loc_id);
      });
    },

    insert(emoji) {
      this.reply_text += emoji;
    },
  }
}
</script>